export default __webpack_public_path__ + "static/media/Landing-8.72d696c5.png";